module.exports = __webpack_public_path__ + "images/gov-uk-logo_5f72579.jpg";